<template>
  <div class="itemPackages">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />
    <ItemPackagesTable
      :isReadOnly="isReadOnly"
      @create-item-package="onCreateItemPackage"
      @edit-item-package="onEditItemPackage"
    />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs';
import ItemPackagesTable from '@/components/ItemPackages/ItemPackagesTable';
import { mapGetters } from 'vuex';
import { coversAccessLevel } from '@/helpers/accessLevel';
import { ITEM_PACKAGES_ACCESS_NODE } from '@/navigation/accessNodes';

export default {
  name: 'ItemPackages',
  components: {
    Breadcrumbs,
    ItemPackagesTable,
  },
  computed: {
    ...mapGetters(['getAccessLevel']),
    isReadOnly() {
      return !coversAccessLevel(this.getAccessLevel(ITEM_PACKAGES_ACCESS_NODE), 'editor');
    },
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('itemPackages') }];
    },
  },
  methods: {
    onCreateItemPackage() {
      this.$router.push({ name: 'ItemPackageCreatePage' });
    },
    onEditItemPackage(itemPackage) {
      this.$router.push({
        name: 'ItemPackageEditPage',
        params: { itemPackageNumber: itemPackage.number },
      });
    },
  },
};
</script>

<style lang="scss"></style>
